import Modal from 'react-modal';
import Button from '../../../../GlobalComponents/Button';
import Input from '../../../../GlobalComponents/Input';
import ModalHeader from '../../../../GlobalComponents/Modal/ModalHeader';
import { useTranslation } from 'react-i18next';
import UseAddEditLabel from '../../Library/Labels/UseAddEditLabel';
import UseGetLabel from '../../Library/Labels/UseGetLabel';
import Loading from '../../../../GlobalComponents/Loading';
import Error from '../../../../GlobalComponents/Error';
import { GetApolloErrorText } from '../../../../GlobalFunctions/helper';
import { UseAuth } from '../../../Auth/Library/UseAuth';
import InputCard from '../../../../GlobalComponents/InputCard';
import eye from '../../../../Media/Images/Icons/eye.webp';
import RadioButton from '../../../../GlobalComponents/RadioButton';

Modal.setAppElement('#root');

const AddEditLabel = ({selectedLabelID,SetSelectedLabelID,OnAddEditSuccess}) => {

    const {user} = UseAuth();
    const {t} = useTranslation();
    const {
        loading,
        error,
        formData,
        AddEditLabel,
        InitFormData,
        SetFormData,
        SetFormLangData,
        GetFormLangValue,
    } = UseAddEditLabel(selectedLabelID,user.lang,(d) => OnAddEditSuccess(d));

    const {
        allLanguageMutations, 
        loading:getLoading,
        error:getError
    } = UseGetLabel(selectedLabelID,user.lang,(d) => {
        InitFormData(d)
    });

    var err = "";
    if(error || getError)
        err = GetApolloErrorText(error || getError)

    return(
        <Modal
            isOpen={true}
            onRequestClose={() => SetSelectedLabelID(null)}
            overlayClassName={"modal-overlay"}
            className={"modal-content"}
        >
            <ModalHeader 
                title = {(selectedLabelID === 0 ? t("AddLabel") : t("EditLabel"))}
                allLanguages = {allLanguageMutations}
                OnClose ={() => SetSelectedLabelID(null)}
                selectedLang = {formData.selectedLang}
                OnLangSelect = {(e) => SetFormData(e)}
            />

            <div className="modal-body">

                {err ?
                    <Error className="no-margin" text={err} />
                :
                    <>
                        {loading || getLoading ?
                            <Loading />
                        : 
                            <>
                                <div className="row">
                                    <div className="col-100">
                                        <InputCard
                                            title = {t("Display")}
                                            icon = {eye}
                                            className = {"form-group"}
                                        >   
                                            <div className="row">
                                                <div className="col-25">
                                                    <div className="form-group">
                                                        
                                                        <label>{t("Active")} </label>
                                                        <div className="radio-container">
                                                            <RadioButton
                                                                text="Ano"
                                                                name="active"
                                                                id="active-1"
                                                                value={1}
                                                                checked = {formData.active === 1 ? true : false}
                                                                OnChange={(e) => SetFormData(e)}
                                                            />
                                                            <RadioButton
                                                                text="Ne"
                                                                name="active"
                                                                id="active-2"
                                                                value={0}
                                                                checked = {formData.active === 0 ? true : false}
                                                                OnChange={(e) => SetFormData(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-25">
                                                    <div className="form-group">
                                                        
                                                        <label>{t("IsPlace")} </label>
                                                        <div className="radio-container">
                                                            <RadioButton
                                                                text="Ano"
                                                                name="isPlace"
                                                                id="isPlace-1"
                                                                value={1}
                                                                checked = {formData.isPlace === 1 ? true : false}
                                                                OnChange={(e) => SetFormData(e)}
                                                            />
                                                            <RadioButton
                                                                text="Ne"
                                                                name="isPlace"
                                                                id="isPlace-2"
                                                                value={0}
                                                                checked = {formData.isPlace === 0 ? true : false}
                                                                OnChange={(e) => SetFormData(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-25">
                                                    <div className="form-group">
                                                        
                                                        <label>{t("IsFreeDelivery")} </label>
                                                        <div className="radio-container">
                                                            <RadioButton
                                                                text="Ano"
                                                                name="isFreeDelivery"
                                                                id="isFreeDelivery-1"
                                                                value={1}
                                                                checked = {formData.isFreeDelivery === 1 ? true : false}
                                                                OnChange={(e) => SetFormData(e)}
                                                            />
                                                            <RadioButton
                                                                text="Ne"
                                                                name="isFreeDelivery"
                                                                id="isFreeDelivery-2"
                                                                value={0}
                                                                checked = {formData.isFreeDelivery === 0 ? true : false}
                                                                OnChange={(e) => SetFormData(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                                      
                                            </div> 
                                        </InputCard>
                                    </div>
                                    <div className={"col-100"}>
                                                
                                        <div className="form-group">
                                            <label>*{t("LabelName")} ({formData.selectedLang})</label>
                                            <Input
                                                name="name"
                                                value={GetFormLangValue("name")}
                                                OnChange={(e) => SetFormLangData(e)}
                                            />
                                        </div>
                                    </div>
                                </div> 
                            </>
                        }
                    </>
                }
            </div>
            <div className="modal-footer">
                <Button
                    className={"btn-primary w-100"}
                    OnClick={() => AddEditLabel()}
                >
                    {(selectedLabelID === 0 ? t("Add") : t("Edit"))}
                </Button>
            </div>

        </Modal>
    )
}

export default AddEditLabel;